import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

const FilterGroup = ({ title, value, options, selected, onToggle }) => (
  <AccordionItem value={value} className="border-b border-neutral-200">
    <AccordionTrigger className="text-left text-[15px] font-semibold tracking-wide uppercase text-neutral-800 hover:no-underline py-4 hover:text-[#6BA797] transition-colors">
      {title}
    </AccordionTrigger>
    <AccordionContent className="pb-4">
      <ul className="space-y-2.5">
        {options.map((opt) => {
          const id = `${value}-${opt}`;
          const checked = selected.includes(opt);
          return (
            <li key={opt} className="flex items-center gap-2.5">
              <Checkbox
                id={id}
                checked={checked}
                onCheckedChange={() => onToggle(value, opt)}
                className="data-[state=checked]:bg-[#6BA797] data-[state=checked]:border-[#6BA797] border-neutral-400 rounded-[2px]"
              />
              <Label
                htmlFor={id}
                className="text-[14px] text-neutral-700 cursor-pointer leading-tight font-normal"
              >
                {opt}
              </Label>
            </li>
          );
        })}
      </ul>
    </AccordionContent>
  </AccordionItem>
);

const FilterAccordion = ({ filters, selected, onToggle, onClear }) => {
  const hasActive = Object.values(selected).some((arr) => arr.length > 0);

  return (
    <aside className="w-full lg:w-64 xl:w-72 shrink-0">
      <Accordion
        type="multiple"
        defaultValue={['colorFamily', 'colorPattern', 'specialFeatures', 'texture', 'doorStyle', 'price']}
        className="w-full"
      >
        <FilterGroup
          title="Color family"
          value="colorFamily"
          options={filters.colorFamily}
          selected={selected.colorFamily}
          onToggle={onToggle}
        />
        <FilterGroup
          title="Color pattern"
          value="colorPattern"
          options={filters.colorPattern}
          selected={selected.colorPattern}
          onToggle={onToggle}
        />
        <FilterGroup
          title="Color Special Features"
          value="specialFeatures"
          options={filters.specialFeatures}
          selected={selected.specialFeatures}
          onToggle={onToggle}
        />
        <FilterGroup
          title="Color Texture"
          value="texture"
          options={filters.texture}
          selected={selected.texture}
          onToggle={onToggle}
        />
        <FilterGroup
          title="Door & Draw Style"
          value="doorStyle"
          options={filters.doorStyle}
          selected={selected.doorStyle}
          onToggle={onToggle}
        />
        <FilterGroup
          title="Price"
          value="price"
          options={filters.price}
          selected={selected.price}
          onToggle={onToggle}
        />
      </Accordion>

      <button
        type="button"
        onClick={onClear}
        disabled={!hasActive}
        className={`mt-5 text-[13px] uppercase tracking-wider font-semibold transition-colors ${
          hasActive
            ? 'text-[#6BA797] hover:text-[#4f8676] cursor-pointer'
            : 'text-neutral-400 cursor-not-allowed'
        }`}
      >
        Remove filters
      </button>
    </aside>
  );
};

export default FilterAccordion;
